import api from "./api";

export const getInvoiceDetails = async (invoiceNumber, customerId) => {
  return await api.get("/api/invoices", {
    params: { invoiceNumber, customerId },
    bypassInterceptor: true
  });
};
